(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequiref400"];
var parcelRegister = parcelRequire.register;
parcelRegister("WY081", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b13f5db5dc170c6$export$2e2bcd8739ae039; });

var $J7ygF = parcelRequire("J7ygF");

var $hvJJn = parcelRequire("hvJJn");
var $0b13f5db5dc170c6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function MainNav(param) {
        var el = param.el;
        (0, $J7ygF._)(this, MainNav);
        this.el = el;
        this.navInner = this.el.querySelector('.main-nav');
        this.childrenButtons = Array.from(this.el.querySelectorAll('.main-links .has-children'));
        this.subMenus = Array.from(this.el.querySelectorAll('.sub-menu'));
        // mobile menu
        this.menuOpeners = Array.from(this.el.querySelectorAll('.menu-opener'));
        this.mobileMenu = document.getElementById('mobile-menu');
        this.menuClosers = Array.from(this.mobileMenu.querySelectorAll('.menu-closer'));
        this.mainMobileMenuButton = document.getElementById('main-mobile-menu-button');
        // scroll watch
        this.lastScrollTop = 0;
        this.trigger = 250;
        this.init();
    }
    (0, $hvJJn._)(MainNav, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                this.setWatch();
                this.childrenButtons.forEach(function(button) {
                    button.addEventListener('click', function(e) {
                        e.preventDefault();
                        var title = button.dataset.title;
                        var subMenu = _this.subMenus.find(function(subMenu) {
                            return subMenu.dataset.title === title;
                        });
                        if (subMenu && subMenu.classList.contains('active')) {
                            subMenu.classList.remove('active');
                            _this.navInner.classList.remove('sub-menu-active');
                        } else if (subMenu) {
                            _this.subMenus.forEach(function(subMenu) {
                                subMenu.classList.remove('active');
                            });
                            subMenu.classList.add('active');
                            _this.navInner.classList.add('sub-menu-active');
                        }
                    });
                });
                this.menuOpeners.forEach(function(opener) {
                    opener.addEventListener('click', function(e) {
                        e.preventDefault();
                        if (document.body.classList.contains('mobile-menu-active')) {
                            document.body.classList.remove('mobile-menu-active');
                            document.body.style.overflow = 'initial';
                            _this.mainMobileMenuButton.innerHTML = 'Menu';
                        } else {
                            document.body.classList.add('mobile-menu-active');
                            document.body.style.overflow = 'hidden';
                            _this.mainMobileMenuButton.innerHTML = 'Close';
                        }
                    });
                });
                this.menuClosers.forEach(function(closer) {
                    closer.addEventListener('click', function(e) {
                        e.preventDefault();
                        document.body.classList.remove('mobile-menu-active');
                        document.body.style.overflow = 'initial';
                    });
                });
                // show nav if hovering near top
                this.el.addEventListener('mouseenter', function() {
                    if (document.body.classList.contains('hide-nav')) _this.showNav();
                });
            }
        },
        {
            // method to show nav
            key: "showNav",
            value: function showNav() {
                document.body.classList.remove('hide-nav');
            }
        },
        {
            // method to hide nav
            key: "hideNav",
            value: function hideNav() {
                document.body.classList.add('hide-nav');
            }
        },
        {
            key: "setWatch",
            value: function setWatch() {
                window.addEventListener('scroll', this.watch.bind(this), {
                    passive: true
                });
            }
        },
        {
            key: "watch",
            value: function watch() {
                var st = window.scrollY; // get scroll top
                if (st > 50) {
                    if (!document.body.classList.contains('scrolled')) document.body.classList.add('scrolled');
                } else if (document.body.classList.contains('scrolled')) document.body.classList.remove('scrolled');
                // if scroll top is less than trigger, show the nav
                if (this.lastScrollTop < this.trigger) this.showNav();
                else // if scroll top is greater than trigger, show or hide nav based on scroll direction
                st > this.lastScrollTop ? this.hideNav() : this.showNav();
                // set last scroll top
                this.lastScrollTop = st <= 0 ? 0 : st;
            }
        }
    ]);
    return MainNav;
}();

});
parcelRegister("J7ygF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $087a0fb22a93b2d1$export$71511d61b312f219; });
function $087a0fb22a93b2d1$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("hvJJn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cbf8ce221d4c5514$export$71511d61b312f219; });
function $cbf8ce221d4c5514$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cbf8ce221d4c5514$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $cbf8ce221d4c5514$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cbf8ce221d4c5514$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});


})();
//# sourceMappingURL=MainNav.690a3785.js.map
